// import "../sass/theme.scss";

// Our modules / classes

import AboutBiz from './modules/Aboutbiz'
import CareerCarousel from './modules/CareerCarousel'
import CareerContent from './modules/CareerContent'
import CompanyLeadership from './modules/CompanyLeadership'
import Navbar from './modules/Navbar'
import ApiAnimation from './modules/ApiAnimation'
import FrameOne from './modules/FrameOne'
import FullVideo from './modules/FullVideo'
import PlayVideo from './modules/PlayVideo'
import Airport from './modules/Airport'
import Wearhouse from './modules/Wearhouse'

const MyNavbar = new Navbar()

if (window.location.pathname == '/careers/') {
	const MyCarousel = new CareerCarousel()
	const MyCareerContent = new CareerContent()
}

if (window.location.pathname == '/company/') {
	const MyCompanyLeadership = new CompanyLeadership()
}
if (window.location.pathname == '/') {
	const MyBiz = new AboutBiz()
	const MyApiAnimation = new ApiAnimation()
	const MyFullVideo = new FullVideo()
	const MyPlayVideo = new PlayVideo()
	const MyAirport = new Airport()
	const MyWearhouse = new Wearhouse()
}
